import CircularProgressCanvas from './gameobjects/canvas/circularprogress/CircularProgress.js';
export default CircularProgressCanvas;